/**
 * On-Device Reminders — portal API client (FEAT-REMINDERS-001).
 * Mirrors the In-App list/designer: raw axios + local x-api-key/x-access-token.
 */
import axios from 'axios';
import { getApiHeaders } from '../../utils/DefaultFunction';

const BASE = () => `${process.env.REACT_APP_API_URL}/reminders`;
const headers = getApiHeaders;

export const remindersApi = {
  list: (params = {}) => axios.get(BASE(), { params, headers: headers() }),
  get: (id) => axios.get(`${BASE()}/${id}`, { headers: headers() }),
  create: (body) => axios.post(BASE(), body, { headers: headers() }),
  update: (id, body) => axios.put(`${BASE()}/${id}`, body, { headers: headers() }),
  publish: (id) => axios.post(`${BASE()}/${id}/publish`, {}, { headers: headers() }),
  pause: (id) => axios.post(`${BASE()}/${id}/pause`, {}, { headers: headers() }),
  resume: (id) => axios.post(`${BASE()}/${id}/resume`, {}, { headers: headers() }),
  duplicate: (id) => axios.post(`${BASE()}/${id}/duplicate`, {}, { headers: headers() }),
  remove: (id) => axios.delete(`${BASE()}/${id}`, { headers: headers() }),
  test: (id) => axios.post(`${BASE()}/${id}/test`, {}, { headers: headers() }),
  statsSummary: (ids) => axios.get(`${BASE()}/stats-summary`, { params: { ids: ids.join(',') }, headers: headers() }),
  catalog: () => axios.get(`${BASE()}/catalog`, { headers: headers() }),
  // Conversion Events module list (goal picker, D10) — same source as the In-App Goal tab.
  conversionEvents: () => axios.get(`${process.env.REACT_APP_API_URL}/event-conversations`, { headers: headers() }),
  getHijri: () => axios.get(`${BASE()}/settings/hijri-overrides`, { headers: headers() }),
  putHijri: (hijri_overrides) => axios.put(`${BASE()}/settings/hijri-overrides`, { hijri_overrides }, { headers: headers() }),
};

export default remindersApi;
